var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 8.83333H20.3334V9.5H9.66675V8.83333H12.0834H12.2905L12.437 8.68689L13.1239 8H16.8763L17.5632 8.68689L17.7096 8.83333H17.9167ZM11.6667 22C11.0262 22 10.5001 21.4739 10.5001 20.8333V11.3333H19.5001V20.8333C19.5001 21.4739 18.9739 22 18.3334 22H11.6667Z",
    stroke: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c9fdaae12bef8c043fe50953bb63ef37.svg";
export { ForwardRef as ReactComponent };